<template>
  <div class="patient-doctor">
    <!-- 患者 -->
    <div class="patient">
      <div
        class="patient_item"
        :class="{ 'patient_item-check': item.isCheck }"
        v-for="item in profiles"
        :key="item.id"
        @click="onProfiles(item.id)"
      >
        <div class="top">
          <span class="name">{{ maskName(item.patientProfileName) }}</span>
          <span class="tag">{{ item.relationName }}</span>
        </div>
        <div class="bottom">
          <span class="sex">{{ item.gender ? '男' : '女' }}</span>
          <span class="age">{{ item.age }} 岁</span>
        </div>
      </div>
    </div>
    <!-- 医生 -->
    <div class="doctors">
      <div
        ref="doctorsDOM"
        class="doctors_item"
        v-for="(item, index) in doctors"
        :key="item.doctorId"
        @click="onDoctors(item)"
        @mouseenter="getDocRemark(item)"
      >
        <a-tooltip
          :getPopupContainer="() => doctorsDOM[index]"
          color="#fff"
          placement="bottom"
          overlayClassName="doctors_item-tooltip"
        >
          <template #title>
            <div class="tooltip_title">
              <div class="header">
                <span class="name">{{ item.doctorName }}</span>
                <span class="department">{{ item.departmentName }} | {{ item.titleName }}</span>
              </div>
              <div class="hospital">{{ item.hospitalName }}</div>
              <div class="remark">
                <RemarkPopover
                  :patientProfileId="profileInfo.id"
                  :initParam="{ doctorId: item.doctorId, ucDoctorId: item.ucDoctorId }"
                  mode="doctor"
                  :remarkData="remarkData"
                  :allowClear="true"
                ></RemarkPopover>
              </div>
              <div class="footer">
                <div class="">来源：{{ item.sourceName }}</div>
                <div class="date">{{ item.bindTime }}</div>
              </div>
            </div>
          </template>
          <div :class="{ 'doctors_item-check': item.isCheck }" class="doctors_item-content">
            <a-image
              :fallback="head_d"
              class="img"
              :height="28"
              :preview="false"
              :width="28"
              :src="item.headerUrl"
            />
            <span class="name">{{ item.doctorName }}医生</span>
          </div>
        </a-tooltip>
      </div>
    </div>
  </div>
</template>

<script setup>
import RemarkPopover from '@/components/RemarkPopover/index.vue'
import head_d from '@/assets/img/chat/head_d.png'
import { maskName } from '@/utils'
import { nextTick, watch } from 'vue'
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { fetchRecommendDoctorDetail } from '@/api/chat'
const doctorsDOM = ref()
const store = useStore()
const patientProfiles = computed(() => store.state.patientFile.info.patientProfiles || [])
const doctorsProfiles = computed(() => store.state.patientFile.info.doctors || [])
const doctors = ref([])
const profiles = ref([])
const doctorInfo = computed(() => store.state.patientFile.bindUser.doctorInfo)
const profileInfo = computed(() => store.state.patientFile.bindUser.profileInfo)
const remarkData = ref({})
const onProfiles = profileId => {
  const bind = { profileId, doctorId: doctorInfo.value.doctorId }
  store.commit('patientFile/SET_BIND_USER', bind)
  store.dispatch('patientFile/getRemark')
  nextTick(() => {
    init()
  })
}
const onDoctors = curDoctor => {
  store.commit('patientFile/SET_LOADING', true)
  const bind = { profileId: profileInfo.value.id, doctorId: curDoctor.doctorId }
  store.commit('patientFile/SET_BIND_USER', bind)
  store.dispatch('patientFile/getRemark')
  store.dispatch('patientFile/getStage')
  store.dispatch('patientFile/getWorkOrderId')
  nextTick(() => {
    init()
  })
  setTimeout(() => {
    store.commit('patientFile/SET_LOADING', false)
  }, 500)
}

// 获取医生协同备注
const getDocRemark = curDoctor => {
  const params = { ucDoctorId: curDoctor.ucDoctorId }
  fetchRecommendDoctorDetail(params)
    .then(res => {
      const { doctorRemarkVO = {} } = res
      remarkData.value = doctorRemarkVO
    })
    .catch(error => {})
}

const init = () => {
  const { doctorId } = doctorInfo.value
  const { id: profileId } = profileInfo.value
  profiles.value = patientProfiles.value.map(item => {
    return {
      ...item,
      isCheck: profileId === item.id
    }
  })
  doctors.value = doctorsProfiles.value.map((item, index) => {
    return {
      ...item,
      isCheck: doctorId === item.doctorId
    }
  })
}
watch(
  () => [doctorInfo.value.doctorId, profileInfo.value.id],
  () => {
    init()
  },
  {
    immediate: true
  }
)
</script>

<style lang="scss" scoped>
.patient-doctor {
  background-color: white;
  border-bottom: 1px solid #e8e8e8;

  .patient {
    background: #1890ff1f;
    display: flex;
    overflow: auto;
    .patient_item {
      padding: 6px 12px;
      text-align: center;
      min-width: 180px;
      flex-shrink: 0;
      cursor: pointer;
      border-radius: 4px;
      .top {
        display: flex;
        align-items: center;
        justify-content: center;
        .name {
          white-space: nowrap;
          font-weight: 500;
        }
        .tag {
          margin-left: 8px;
          font-weight: 500;
          font-size: 10px;
          color: rgba(24, 144, 255, 0.8);
          padding: 2px;
          border-radius: 4px;
          background: rgba(24, 144, 255, 0.12);
          flex-shrink: 0;
          max-width: 100px;
        }
      }
      .bottom {
        .sex {
          margin: 0 4px;
        }
      }
    }
    .patient_item-check {
      background: #1890ff;
      color: #fff;
      .top {
        .tag {
          background: rgba(255, 255, 255, 0.24);
          color: #ffffffe6;
        }
      }
    }
  }
}

.doctors {
  display: flex;
  overflow: auto;
  .doctors_item {
    font-size: 12px;
    color: #333333;
    margin: 8px 0;
    padding: 0 12px;
    border-right: 1px solid #e8e8e8;
    cursor: pointer;
    min-width: 150px;
    flex-shrink: 0;
    &:last-child {
      border: none;
    }
    .doctors_item-content {
      display: flex;
      align-items: center;
      // justify-content: center;
      padding: 4px 12px;
      border: 1px solid #fff;
      border-radius: 6px;
      .name {
        // flex-grow: 1;
        white-space: nowrap;
      }
      ::v-deep(.ant-image) {
        flex-shrink: 0;
        overflow: hidden;
        border-radius: 50%;
        margin-right: 8px;
        .img {
          width: 28px;
          height: 28px;
        }
      }
    }
    .doctors_item-check {
      color: #1890ff;
      border-color: #1890ff;
      background-color: rgba(24, 144, 255, 0.12);
    }
    ::v-deep(.doctors_item-tooltip) {
      width: 285px;
      .ant-tooltip-content {
        .ant-tooltip-inner {
          border-radius: 8px;
          padding: 16px 12px;
        }
      }
      .tooltip_title {
        font-size: 12px;
        color: #3b3b3b;
        .header {
          font-weight: 400;
          font-size: 12px;
          color: #999999;
          .name {
            color: #1a1a1a;
            font-size: 14px;
            margin-right: 12px;
          }
          .department {
            color: #999999;
          }
        }
        .hospital {
          margin-top: 9px;
        }
        .remark {
          // margin-top: 9px;
        }
        .footer {
          margin-top: 16px;
          display: flex;
          justify-content: space-between;
          .date {
            color: #999999;
          }
        }
      }
    }
  }
}
</style>
